export const TransactionsProducer = (transactionsService, userService, pageSize) => {
  return {
    getTransactions(startDate, endDate, cashBoxIds, page = 1, section, cash, type) {
      return new Promise((resolve, reject) => {
        let data = {
          startDate: startDate ? startDate.format('YYYY-MM-DD') : '',
          endDate: endDate ? endDate.format('YYYY-MM-DD') : '',
          size: pageSize,
          page: page,
          cash: cash,
          type: type ? type : undefined
        }
        if (cashBoxIds !== null ) {
          data.cashBoxIds = cashBoxIds
        }
        if (section) {
          data.section = section;
        }

        transactionsService.getTransactions(data)
          .then((response) => {

            let transactions = response.data.transactions;
            let ids = [...new Set(transactions.map(tr => tr.userId))];
            if (ids.length === 0) {
              resolve({
                transactions: transactions,
                totalElements: response.data.totalElements,
                totalPages: response.data.totalPages
              });
            } else {
              userService.listUsersByIds(ids.join(",")).then((usersResponse) => {
                let users = usersResponse.data.users;
                let userMap = {};
                users.forEach(user => {
                  userMap[user.id] = user
                })
                transactions.forEach(tr => {
                  tr.user = userMap[tr.userId];
                })
                resolve({
                  transactions: transactions,
                  totalElements: response.data.totalElements,
                  totalPages: response.data.totalPages
                });
              }).catch(reject)
            }
          }).catch(reject)
      });
    }
  }

}
